import React, { ReactNode, useRef, useState } from 'react';
import {
  Button,
  createStyles,
  Grid,
  makeStyles,
  Theme,
  Typography,
  Modal,
  withStyles
} from '@material-ui/core';
import { UseFormHandleSubmit } from 'react-hook-form';
import { TDocumentModal, TPictureModal } from '../types/CloudStorageModal';
import { useHistory } from 'react-router-dom';
import {
  ModalCancelButton,
  ModalSubmitButton
} from './parts/cloudStorage/style/style';
import {
  acceptablePictureTypeStr,
  acceptableFileTypeStr
} from '../utils/common';

type Tprops = {
  children: ReactNode;
  modalOpen: boolean;
  setModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  onFileInputChange: any;
  resetFile: any;
  onSend: any;
  title: string;
  handleSubmit: UseFormHandleSubmit<TDocumentModal | TPictureModal>;
  getRootProps: any;
  getInputProps: any;
};

/**
 * クラウドストレージ用共通モーダル
 * @param props
 * @constructor
 */
export const CloudStorageModal: React.FC<Tprops> = (props: Tprops) => {
  const {
    children,
    modalOpen,
    setModalOpen,
    onFileInputChange,
    resetFile,
    onSend,
    title,
    handleSubmit,
    getRootProps,
    getInputProps
  } = props;

  const inputRef = useRef<any>(null);
  const classes = useStyles();
  const history = useHistory();
  const [disable, setDisable] = useState<boolean>(false);

  const fileUpload = () => {
    if (disable == true) {
      inputRef.current.click();
    }
    setDisable(false);
  };

  return (
    <Modal
      open={modalOpen}
      onClose={() => setModalOpen(false)}
      aria-labelledby='simple-modal-title'
      aria-describedby='simple-modal-description'
      className={classes.modal}
    >
      <div className={classes.paper}>
        <div className={classes.header}>
          <Grid container justify={'center'}>
            <h1 style={{ marginBottom: 24, fontSize: 24 }}>{title}</h1>
            <Grid
              item
              xs={12}
              className={classes.headerDropArea}
              {...getRootProps()}
            >
              <input {...getInputProps()} />

              {(history.location.pathname === '/pictures' ||
                history.location.pathname === '/sharepicture') && (
                <Typography variant='body1' align='center' gutterBottom={true}>
                  画像をドラッグ&ドロップしてください。
                </Typography>
              )}
              {(history.location.pathname === '/files' ||
                history.location.pathname === '/sharefile') && (
                <Typography variant='body1' align='center' gutterBottom={true}>
                  資料をドラッグ&ドロップしてください。
                </Typography>
              )}

              <Grid
                item
                style={{ textAlign: 'center', marginTop: 10, marginBottom: 10 }}
              >
                <RefButton
                  variant='contained'
                  disabled={disable}
                  onClick={() => {
                    setDisable(true);
                    fileUpload();
                  }}
                >
                  ファイルを参照
                </RefButton>
              </Grid>

              {(history.location.pathname === '/pictures' ||
                history.location.pathname === '/sharepicture') && (
                <>
                  <Typography
                    variant='body2'
                    align='center'
                    gutterBottom={true}
                  >
                    または、ファイル参照より画像を選択してください。
                  </Typography>
                  <Typography
                    variant='body2'
                    align='center'
                    gutterBottom={true}
                  >
                    ※保存可能なファイル形式：{acceptablePictureTypeStr()}
                  </Typography>
                </>
              )}
              {(history.location.pathname === '/files' ||
                history.location.pathname === '/sharefile') && (
                <>
                  <Typography
                    variant='body2'
                    align='center'
                    gutterBottom={true}
                  >
                    または、ファイル参照より資料を選択してください。
                  </Typography>
                  <Typography
                    variant='body2'
                    align='center'
                    gutterBottom={true}
                  >
                    ※保存可能なファイル形式：{acceptableFileTypeStr()}
                  </Typography>
                  <Typography
                    className={classes.modalAnnotation}
                    variant='body2'
                    align='center'
                    gutterBottom={true}
                  >
                    電子契約はpdf形式のみ送信可能です。
                  </Typography>
                </>
              )}
            </Grid>
          </Grid>
        </div>

        {children}

        <Grid item xs={12} className={classes.modalFooter}>
          <ModalCancelButton
            variant='contained'
            onClick={() => {
              resetFile();
              setModalOpen(false);
            }}
          >
            キャンセル
          </ModalCancelButton>
          <ModalSubmitButton variant='contained' onClick={handleSubmit(onSend)}>
            追加
          </ModalSubmitButton>
        </Grid>

        <input
          hidden
          ref={inputRef}
          type='file'
          multiple
          onChange={onFileInputChange}
        />
      </div>
    </Modal>
  );
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    modal: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    paper: {
      backgroundColor: theme.palette.background.paper,
      borderRadius: theme.spacing(2),
      boxShadow: theme.shadows[5],
      width: '70%',
      maxHeight: '90vh',
      overflowY: 'scroll'
    },

    header: {
      backgroundColor: theme.palette.background.paper,
      padding: theme.spacing(2, 4, 3),
      borderRadius: theme.spacing(2, 2, 0, 0)
    },
    headerTitle: {
      fontSize: 30,
      marginTop: 10,
      marginBottom: 10
    },
    headerDropArea: {
      border: '1px dashed silver',
      padding: 20,
      borderRadius: 10
    },

    footer: {
      backgroundColor: theme.palette.background.paper,
      padding: theme.spacing(2, 4, 3),
      borderRadius: theme.spacing(0, 0, 2, 2)
    },

    modalFooter: {
      // モーダル下部
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      borderTop: '1px solid #cfcfcf',
      padding: 30
    },

    modalAnnotation: {
      color: '#ff0000',
      textAlign: 'center'
    }
  })
);

//ファイル参照ボタン
export const RefButton = withStyles(() => ({
  root: {
    backgroundColor: '#007dff',
    color: '#fff',
    width: 160,
    height: 48,
    '&:hover': {
      backgroundColor: '#2691ff',
      boxShadow: 3
    }
  }
}))(Button);
